import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
import delay from 'lodash/delay';
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
import { SLOW_TIMER } from '~/const/timers';
import { OLAPIC_URL } from '~/const/3rd';
export default {
  props: {
    olapic: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  mounted: function mounted() {
    var _this = this;

    this.asyncScript(OLAPIC_URL).then(function () {
      delay(_this.onOlapicLoad, SLOW_TIMER);
    }).catch(function (err) {
      _this.$logger.error(err);
    });
    this.$watch('product', function () {
      _this.onOlapicLoad();
    });
  },
  updated: function updated() {
    this.onOlapicLoad();
  },
  methods: {
    doRender: function doRender(options) {
      window.olapic.prepareWidget(options, {
        renderNow: true,
        force: true
      });
    },
    onOlapicLoad: function onOlapicLoad() {
      var _this2 = this;

      if (window.OlapicSDK) {
        window.OlapicSDK.conf.set('apikey', this.olapic.apikey);
        window.olapic = new window.OlapicSDK.Olapic(function (o) {
          window.olapic = o;

          _this2.doRender({
            id: _this2.olapic.instance,
            wrapper: 'olapic_specific_widget',
            tags: _this2.olapic.mpnCode,
            lang: "".concat(_this2.locale.language, "_").concat(_this2.locale.market),
            useOpi: true
          });
        });
      }
    }
  }
};